<script lang="ts">
  export let errors: string[] | undefined | null
  $: displayedErrors = errors?.filter(e => !!e)
</script>

{#if displayedErrors}
  <div class="errors">
    {#each displayedErrors as error}
      <p class="error-text">{error}</p>
    {/each}
  </div>
{/if}